import * as actions from './LoginTypes';

export const setLogin = data => {
    localStorage.setItem("loggedIn", data.loggedIn);
    return {
        type: actions.SET_LOGIN,
        payload: data
    }
}